import React from "react";
import RVBCalculator from "../../PicesForPages/RentingVsBuyingCalculator.webp";
import RVsBCalculator from "../CalculatorAndChart/RvsBCalculator";

function RentingVsBuyingCalculator() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={RVBCalculator}
          alt="RVBCalculatorImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Renting Vs Buying Calculator</span>
        </div>
      </div>
      <RVsBCalculator />
    </div>
  );
}

export default RentingVsBuyingCalculator;
